import { render, staticRenderFns } from "./PaginationTable.vue?vue&type=template&id=3fb3c36e&scoped=true&"
import script from "./PaginationTable.vue?vue&type=script&lang=js&"
export * from "./PaginationTable.vue?vue&type=script&lang=js&"
import style0 from "./PaginationTable.vue?vue&type=style&index=0&id=3fb3c36e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb3c36e",
  null
  
)

export default component.exports